module.exports = __webpack_public_path__ + "img/pic-2.50e4455a.png";